import { render, staticRenderFns } from "./JourneyNodeCard.vue?vue&type=template&id=76064e71&scoped=true&"
import script from "./JourneyNodeCard.vue?vue&type=script&lang=js&"
export * from "./JourneyNodeCard.vue?vue&type=script&lang=js&"
import style0 from "./JourneyNodeCard.vue?vue&type=style&index=0&id=76064e71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76064e71",
  null
  
)

export default component.exports